import type { BillingTranslation } from './en';

/** Arabic (Modern Standard). Pending review by native speakers, as the note in the interface says. */
export const billingAr: BillingTranslation = {
  nav: 'الخطة والفوترة',
  title: 'الخطة والفوترة',
  description: 'خطتك، وما استخدمته هذا الشهر، وفواتيرك، والاسم الظاهر على رسائلك.',
  loading: 'جارٍ تحميل خطتك',
  checkout: {
    done: 'شكرًا لك. يجري تأكيد الدفع، وستتغير خطتك بعد لحظات.',
    cancelled: 'غادرت صفحة الدفع. لم يُخصم أي مبلغ.',
  },
  plan: {
    title: 'خطتك',
    none: 'بلا خطة: لا شيء محدود',
    price: '{{price}} شهريًا',
    provider: {
      free: 'مجانية. يمكنك الترقية عندما تحتاج إلى المزيد.',
      stripe: 'تُدفع بالبطاقة عبر Stripe.',
      whmcs: 'يفوترك مزوّد الخدمة. استخدم منطقة العملاء للدفع أو لتغيير الخطة.',
      manual: 'تُفوتر بفاتورة من هذا الخادم.',
    },
    grace:
      'تعذّر الدفع. تبقى خطتك حتى {{date}}. ادفع الفاتورة قبل ذلك للاحتفاظ بها، وإلا تنتقل مساحة العمل إلى الخطة المجانية.',
    trial: 'فترة تجريبية حتى {{date}}. بعدها تنتقل مساحة العمل إلى الخطة المجانية ما لم تختر خطة.',
    renews: 'تتجدد في {{date}}.',
    ends: 'تنتهي في {{date}}، ولن تتجدد.',
  },
  status: {
    none: 'بلا اشتراك',
    trialing: 'فترة تجريبية',
    active: 'نشط',
    past_due: 'الدفع مستحق',
    unpaid: 'غير مدفوع',
    canceled: 'ملغى',
    incomplete: 'بانتظار الدفع',
    paused: 'متوقف مؤقتًا',
  },
  providers: {
    free: 'مجاني',
    stripe: 'Stripe',
    whmcs: 'WHMCS',
    manual: 'فواتير من هذا الخادم',
  },
  actions: {
    manage: 'إدارة الفوترة',
    clientArea: 'فتح منطقة العملاء',
    upgrade: 'ترقية',
    chooseLabel: 'الترقية إلى {{plan}}',
  },
  plans: {
    title: 'الخطط',
    description: 'اختر خطة وادفع ثمنها في صفحة دفع آمنة. يمكنك تغييرها أو إلغاؤها لاحقًا.',
    limit: '{{limit}}: {{value}}',
    unlimited: 'بلا حد',
    trialDays: 'فترة تجريبية: {{n}} يومًا مجانًا',
    readOnly: 'يغيّر الخطة من يديرون الفوترة فقط.',
  },
  usage: {
    title: 'الاستخدام هذا الشهر',
    details: 'التفاصيل وميزانية الذكاء الاصطناعي',
  },
  invoices: {
    title: 'الفواتير',
    loading: 'جارٍ تحميل الفواتير',
    number: 'الفاتورة',
    date: 'التاريخ',
    total: 'الإجمالي',
    status: 'الحالة',
    links: 'الروابط',
    pay: 'ادفع',
    view: 'عرض',
    pdf: 'PDF',
    empty: 'لا توجد فواتير بعد.',
    allInReports: 'كل الفواتير',
    inClientArea: 'فواتيرك في منطقة العملاء لدى مزوّد الخدمة.',
    statuses: {
      draft: 'مسودة',
      open: 'مفتوحة',
      paid: 'مدفوعة',
      void: 'ملغاة',
      uncollectible: 'لم تُحصَّل',
    },
  },
  sender: {
    title: 'اسم مُرسِل الرسائل',
    description:
      'الاسم الذي يراه الناس على رسائل هذه المساحة، مثل الدعوات والإيصالات وإشعارات الدفع.',
    loading: 'جارٍ تحميل اسم المُرسِل',
    label: 'اسم المُرسِل',
    hint: 'اتركه فارغًا لاستخدام اسم مساحة العمل ({{name}}).',
    save: 'حفظ اسم المُرسِل',
    saved: 'حُفظ اسم المُرسِل.',
  },
  suspended: {
    title: 'مساحة العمل هذه معلّقة',
    description:
      'يمكنك التصفح، لكن لا يمكن تغيير أي شيء، وتظهر الدردشة على موقعك غير متصلة. تواصل مع مزوّد الخدمة لإعادة تفعيلها.',
  },
  provisioning: {
    queued: 'يجري إعداد الدردشة لهذه العلامة التجارية. يستغرق ذلك نحو دقيقة.',
    running: 'إعداد الدردشة: {{step}}',
    failed: 'توقف إعداد الدردشة. {{error}} اختر «اربط Chatwoot» للمحاولة مجددًا: يكمل من حيث توقف.',
    steps: {
      account: 'إنشاء الحساب',
      integration_user: 'إضافة مستخدم Hamnivo',
      account_user: 'منح Hamnivo صلاحية الوصول',
      inbox: 'إنشاء صندوق الوارد',
      bot: 'إضافة المساعد الذكي',
      bot_attached: 'ربط المساعد الذكي',
      webhook: 'تشغيل التحديثات',
      dashboard_app: 'إضافة المساعد المرافق',
      done: 'الإنهاء',
    },
  },
  signup: {
    closed:
      'التسجيل في هذا الخادم بالدعوة فقط. إن تلقيت دعوة، فاستخدم العنوان الذي أُرسلت إليه الدعوة.',
    closedError:
      'لا يُنشئ هذا الخادم حسابات إلا للعناوين المدعوّة. استخدم العنوان الذي أُرسلت إليه دعوتك، أو اطلب دعوة.',
    captcha: 'أكّد أنك إنسان',
    captchaMissing: 'أكمل التحقق أعلاه، ثم حاول مجددًا.',
    captchaFailed: 'لم ينجح التحقق. حاول مرة أخرى.',
    captchaUnavailable:
      'تعذّر تحميل التحقق. تحقّق من اتصالك أو أوقف أدوات حظر المحتوى، ثم أعد تحميل الصفحة.',
  },
  tenants: {
    suspended: 'معلّقة: للقراءة فقط',
    createClosed:
      'إنشاء مساحات العمل متوقف في هذا الخادم. ينشئها مزوّد الخدمة، أو يدعوك إلى إحداها.',
  },
  platform: {
    nav: 'التسجيل والفوترة',
    signup: {
      title: 'التسجيل العام',
      description:
        'هل يمكن لأي شخص إنشاء حساب ومساحة عمل في هذا الخادم. يمكن للمدعوّين الانضمام دائمًا.',
      loading: 'جارٍ تحميل إعداد التسجيل',
      open: 'مفتوح للجميع',
      closed: 'بالدعوة فقط',
      overridden: 'غُيّر هنا في {{time}}',
      envDefault: 'إعداد الخادم (HAMNIVO_PUBLIC_SIGNUP): {{state}}',
      openShort: 'مفتوح',
      closedShort: 'مغلق',
      turnstileOn: 'يتحقق Cloudflare Turnstile من كل تسجيل.',
      turnstileOff:
        'Cloudflare Turnstile متوقف. اضبط TURNSTILE_SITE_KEY وTURNSTILE_SECRET_KEY لتشغيله.',
      defaultPlan: 'تبدأ مساحات العمل الجديدة على: {{plan}}',
      unlimited: 'بلا خطة (لا شيء محدود)',
      close: 'إغلاق التسجيل',
      openIt: 'فتح التسجيل',
      follow: 'استخدام إعداد الخادم',
      needsAdmin: 'يغيّر هذا مديرو المنصة فقط.',
      saved: 'حُفظ إعداد التسجيل.',
    },
    plans: {
      title: 'الخطط',
      description: 'أضف الخطط أو غيّرها بأمر الفوترة plan:set (راجع دليل تشغيل Hamnivo كخدمة).',
      loading: 'جارٍ تحميل الخطط',
      name: 'الاسم',
      key: 'المفتاح',
      price: 'السعر الشهري',
      trial: 'الفترة التجريبية',
      stripe: 'سعر Stripe',
      trialDays: '{{n}} يومًا',
    },
    keys: {
      title: 'مفاتيح واجهة المشغّل',
      description:
        'تستخدم أنظمة الفوترة مثل WHMCS مفتاحًا لإنشاء مساحات العمل وتعليقها وتغييرها. يظهر المفتاح مرة واحدة عند إنشائه.',
      loading: 'جارٍ تحميل المفاتيح',
      name: 'الاسم',
      nameHint: 'أين يُستخدم المفتاح، مثل WHMCS.',
      nameRequired: 'أعطِ المفتاح اسمًا.',
      create: 'إنشاء مفتاح',
      created: 'انسخ هذا المفتاح الآن واحفظه في نظام الفوترة. لن يظهر مرة أخرى.',
      copy: 'نسخ المفتاح',
      copied: 'نُسخ المفتاح.',
      copyFailed: 'تعذّر النسخ. حدّد المفتاح وانسخه بنفسك.',
      empty: 'لا توجد مفاتيح بعد.',
      prefix: 'يبدأ بـ',
      createdAt: 'أُنشئ',
      lastUsed: 'آخر استخدام',
      status: 'الحالة',
      never: 'أبدًا',
      active: 'نشط',
      revoked: 'مُلغى',
      revoke: 'إلغاء',
      revokeLabel: 'إلغاء المفتاح {{name}}',
      revokeTitle: 'إلغاء المفتاح {{name}}؟',
      revokeBody: 'تتوقف الأنظمة التي تستخدم هذا المفتاح فورًا. لا يمكن التراجع عن ذلك.',
      revokedDone: 'أُلغي المفتاح.',
    },
    tenant: {
      title: 'الخطة والحالة',
      loading: 'جارٍ تحميل الخطة',
      plan: 'الخطة',
      noPlan: 'بلا خطة (لا شيء محدود)',
      trial: 'فترة تجريبية حتى {{date}}',
      provider: 'الفوترة عبر',
      graceLabel: 'الدفع',
      grace: 'تعذّر؛ مهلة سماح حتى {{date}}',
      usage: 'الاستخدام في هذه الفترة',
      assign: 'تغيير الخطة',
      assignTitle: 'تغيير خطة {{name}}',
      planField: 'الخطة',
      pickPlan: 'اختر خطة',
      startTrial: 'بدء الفترة التجريبية للخطة ({{n}} يومًا)، ثم العودة إلى الخطة المجانية',
      stripeNote: 'تدفع مساحة العمل هذه عبر Stripe. غيّر خطتها في Stripe، أو ألغِ الاشتراك أولًا.',
      assigned: 'تغيّرت الخطة.',
      suspend: 'تعليق',
      reactivate: 'إعادة التفعيل',
      suspendTitle: 'تعليق {{name}}؟',
      reactivateTitle: 'إعادة تفعيل {{name}}؟',
      suspendBody:
        'يمكن لأعضائها تسجيل الدخول والتصفح، لكن لا يمكن تغيير أي شيء، وتظهر الدردشة على مواقعها غير متصلة.',
      reactivateBody: 'يعود كل شيء إلى العمل، بما في ذلك الدردشة على مواقعها.',
      reason: 'السبب',
      reasonHint: 'يُسجَّل في سجل تدقيق مساحة العمل وفي سجل تدقيق المنصة.',
      reasonShort: 'اكتب سببًا من 3 أحرف على الأقل.',
      suspendedDone: 'عُلّقت مساحة العمل.',
      reactivatedDone: 'أُعيد تفعيل مساحة العمل.',
    },
  },
};
